import { ClaimV2CornSchema } from '@eigtech/claims-v2-types';
import { JobCornSchema } from '@eigtech/restoration-types';
import { cornType } from '@eigtech/shared-corn';
import { z } from 'zod';
export const inspectionsServiceCorn = (resourceType) => cornType('inspections', resourceType);
export const InspectionsServiceCornSchema = inspectionsServiceCorn();
export const InspectionCornSchema = inspectionsServiceCorn('inspection');
export const InspectionEntityCornSchema = z.union([ClaimV2CornSchema, JobCornSchema]);
